import { For, reactive, onCleanup } from 'cdui-js';
import { OPEN_ACCOUNT_IMAGE_MAX_BYTES, UploadImage } from '../../components/Upload';
import { AuthSensitiveImage } from '../../components/AuthSensitiveImage';
import { DiFiLoading } from '../../../../components/DiFi/DiFiLoading';
import { revokeAuthFileBlobUrl } from '../../../../lib/authFileBlob';

const CloseMark = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7.5" fill="#FF4E4E" stroke="#FFFFFF" />
    <path
      d="M5.21475 10.7865L10.7878 5.21348M10.7878 10.7865L5.21475 5.21348"
      stroke="#FFFFFF"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  </svg>
);

/** 虚线 + 号上传按钮（描边跟随亮/暗主题变量） */
const UploadButtonFace = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      class="upload-proof-btn-border"
      d="M53.9004 0C53.9004 0.276142 54.1242 0.5 54.4004 0.5H56C56.6723 0.5 57.3235 0.588469 57.9424 0.753906C58.2035 0.823578 58.4698 0.672601 58.5479 0.416016C60.9158 1.21122 62.7874 3.08334 63.583 5.45117C63.3268 5.52946 63.1765 5.79673 63.2461 6.05762C63.4115 6.67652 63.5 7.32766 63.5 8V9.59961C63.5 9.87575 63.7239 10.0996 64 10.0996V15.5C63.7239 15.5 63.5 15.7239 63.5 16V19.2002C63.5001 19.4762 63.7239 19.7002 64 19.7002V25.0996C63.724 25.0996 63.5002 25.3236 63.5 25.5996V28.7998C63.5 29.0759 63.7239 29.2998 64 29.2998V34.7002C63.7239 34.7002 63.5 34.9241 63.5 35.2002V38.4004C63.5002 38.6764 63.724 38.9004 64 38.9004V44.2998C63.7239 44.2998 63.5001 44.5238 63.5 44.7998V48C63.5 48.2761 63.7239 48.5 64 48.5V53.9004C63.7239 53.9004 63.5 54.1242 63.5 54.4004V56C63.5 56.5884 63.4325 57.1605 63.3047 57.709L63.2461 57.9424C63.1765 58.2032 63.327 58.4695 63.583 58.5479C62.7876 60.916 60.916 62.7876 58.5479 63.583C58.4794 63.3596 58.2683 63.2169 58.042 63.2305L57.9424 63.2461C57.3235 63.4115 56.6723 63.5 56 63.5H54.4004C54.1242 63.5 53.9004 63.7239 53.9004 64H48.5C48.5 63.7239 48.2761 63.5 48 63.5H44.7998C44.5238 63.5001 44.2998 63.7239 44.2998 64H38.9004C38.9004 63.724 38.6764 63.5002 38.4004 63.5H35.2002C34.9241 63.5 34.7002 63.7239 34.7002 64H29.2998C29.2998 63.7239 29.0759 63.5 28.7998 63.5H25.5996C25.3236 63.5002 25.0996 63.724 25.0996 64H19.7002C19.7002 63.7239 19.4762 63.5001 19.2002 63.5H16C15.7239 63.5 15.5 63.7239 15.5 64H10.0996C10.0996 63.7239 9.87575 63.5 9.59961 63.5H8C7.32766 63.5 6.67652 63.4115 6.05762 63.2461C5.79673 63.1765 5.52946 63.3268 5.45117 63.583C3.08334 62.7874 1.21122 60.9158 0.416016 58.5479C0.672601 58.4698 0.823577 58.2035 0.753906 57.9424L0.695312 57.709C0.567522 57.1605 0.5 56.5884 0.5 56V54.4004C0.5 54.1242 0.276142 53.9004 0 53.9004V48.5C0.241713 48.5 0.443708 48.3286 0.490234 48.1006L0.5 48V44.7998C0.499895 44.5238 0.276077 44.2998 0 44.2998V38.9004C0.241581 38.9004 0.443564 38.7288 0.490234 38.501L0.5 38.4004V35.2002C0.5 34.9241 0.276142 34.7002 0 34.7002V29.2998C0.276142 29.2998 0.5 29.0759 0.5 28.7998V25.5996C0.49979 25.3236 0.276013 25.0996 0 25.0996V19.7002C0.241646 19.7002 0.443635 19.5287 0.490234 19.3008L0.5 19.2002V16C0.5 15.7239 0.276142 15.5 0 15.5V10.0996C0.276142 10.0996 0.5 9.87575 0.5 9.59961V8C0.5 7.41158 0.567522 6.83952 0.695312 6.29102L0.753906 6.05762C0.823603 5.79643 0.672767 5.52911 0.416016 5.45117C1.21142 3.0835 3.0835 1.21142 5.45117 0.416016C5.5192 0.64012 5.73127 0.783094 5.95801 0.769531L6.05762 0.753906C6.67652 0.588469 7.32766 0.5 8 0.5H9.59961C9.87575 0.5 10.0996 0.276142 10.0996 0H15.5C15.5 0.276142 15.7239 0.5 16 0.5H19.2002C19.4418 0.499908 19.6429 0.328415 19.6895 0.100586L19.7002 0H25.0996C25.0996 0.276012 25.3236 0.499789 25.5996 0.5H28.7998C29.0759 0.5 29.2998 0.276142 29.2998 0H34.7002C34.7002 0.276142 34.9241 0.5 35.2002 0.5H38.4004C38.6419 0.499817 38.8431 0.328373 38.8896 0.100586L38.9004 0H44.2998C44.2998 0.276077 44.5238 0.499893 44.7998 0.5H48C48.2761 0.5 48.5 0.276142 48.5 0H53.9004Z"
      stroke-linecap="round"
      stroke-dasharray="3 6"
    />
    <path
      class="upload-proof-btn-plus"
      d="M32 27V37"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="upload-proof-btn-plus"
      d="M27 32H37"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export type UploadProofChangePayload = {
  type: string;
  url: string;
  data: any;
  /** 多图：add / remove；单图删除仍传 url: '' */
  action?: 'add' | 'remove';
};

export type UploadProofProps = {
  useFor?: string;
  busId?: string;
  /** 单图回填（兼容） */
  img?: string;
  /** 多图回填；优先于 img */
  imgs?: string[];
  /** 最多张数，默认 1 */
  maxCount?: number;
  change?: (payload: UploadProofChangePayload) => void;
};

export const UploadProof = (props: UploadProofProps) => {
  const state = reactive({
    /** 当前预览的 path（服务端路径） */
    previewPath: '',
    /** 关闭预览后短暂锁，防止点击穿透立刻再次打开 */
    previewCloseLock: false,
    uploading: false,
    /** 本会话刚上传的本地 blob，按服务端 path 索引 */
    localByPath: {} as Record<string, string>,
  });

  let closeLockTimer: ReturnType<typeof setTimeout> | null = null;

  const maxCount = () => {
    const n = Number(props.maxCount);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
  };

  const paths = () => {
    if (Array.isArray(props.imgs)) return props.imgs.filter(Boolean);
    if (props.img) return [props.img];
    return [] as string[];
  };

  const isMulti = () => maxCount() > 1;

  const displaySrc = (path: string) => state.localByPath[path] || path;

  const revokeLocal = (path: string) => {
    const blob = state.localByPath[path];
    if (blob) {
      revokeAuthFileBlobUrl(blob);
      // reactive proxy 禁止 delete，置空即可（displaySrc 用 truthy）
      state.localByPath[path] = '';
    }
  };

  const clearAllLocal = () => {
    Object.keys(state.localByPath).forEach((p) => {
      const blob = state.localByPath[p];
      if (blob) revokeAuthFileBlobUrl(blob);
    });
    state.localByPath = {};
  };

  const lockPreviewReopen = () => {
    state.previewCloseLock = true;
    if (closeLockTimer) clearTimeout(closeLockTimer);
    closeLockTimer = setTimeout(() => {
      state.previewCloseLock = false;
      closeLockTimer = null;
    }, 320);
  };

  const onDelete = (e: Event, path: string) => {
    e.stopPropagation();
    e.preventDefault();
    if (state.previewPath === path) state.previewPath = '';
    revokeLocal(path);
    if (isMulti()) {
      props.change?.({
        type: '',
        url: path,
        data: null,
        action: 'remove',
      });
    } else {
      clearAllLocal();
      props.change?.({
        type: '',
        url: '',
        data: null,
      });
    }
  };

  onCleanup(() => {
    clearAllLocal();
    if (closeLockTimer) clearTimeout(closeLockTimer);
  });

  const showUploader = () => paths().length < maxCount();

  return (
    <div class="flex-row flex-wrap align-center gap-12px padding-y-XS">
      <For each={paths()}>
        {(path) => (
          <div
            class="upload-proof-thumb relative"
            style={{ width: '64px', height: '64px', 'flex-shrink': 0, overflow: 'unset' }}
            onclick={() => {
              if (state.previewCloseLock) return;
              state.previewPath = path;
            }}
          >
            <AuthSensitiveImage
              class="round"
              style={{ width: '64px', height: '64px', 'object-fit': 'cover' }}
              path={displaySrc(path)}
              previewOpen={state.previewPath === path}
              onPreviewClose={() => {
                state.previewPath = '';
                lockPreviewReopen();
              }}
            />
            <div class="upload-proof-close absolute" onclick={(e) => onDelete(e, path)}>
              <CloseMark />
            </div>
          </div>
        )}
      </For>

      {state.uploading ? (
        <div
          class="upload-proof-loading relative flex align-center justify-center round bg-c-XD"
          style={{ width: '64px', height: '64px', 'flex-shrink': 0 }}
        >
          <DiFiLoading overlay={false} size="sm" />
        </div>
      ) : null}

      {showUploader() && !state.uploading ? (
        <div class="relative" style={{ width: '64px', height: '64px', 'flex-shrink': 0 }}>
          <UploadButtonFace />
          <UploadImage
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              'z-index': 2,
            }}
            useFor={props.useFor}
            busId={props.busId}
            maxSize={OPEN_ACCOUNT_IMAGE_MAX_BYTES}
            restrictImageType={true}
            showLoading={false}
            change={(data) => {
              if (data.status === 'loading') {
                state.uploading = true;
                state.previewPath = '';
                return;
              }
              state.uploading = false;
              if (data.status === 'error') return;
              if (data.filePath) {
                state.previewPath = '';
                if (data.localPreviewUrl) {
                  if (!isMulti()) clearAllLocal();
                  state.localByPath[data.filePath] = data.localPreviewUrl;
                }
                props.change?.({
                  type: '',
                  url: data.filePath,
                  data: {},
                  action: isMulti() ? 'add' : undefined,
                });
              }
            }}
          />
        </div>
      ) : null}
    </div>
  );
};
